import { KastWebSdkClient } from '@kalyzee/kast-web-sdk';
import { CompatibilityInfo as CompatibilityInfoApiRest } from '@kalyzee/kast-web-sdk/http';
import { CompatibilityInfo as CompatibilityInfoWebsocketServer } from '@kalyzee/kast-web-sdk/websocket';
import { getHttpApiUrl, getWebsocketApiUrl } from './request';


export const buildSDKClient = () => new KastWebSdkClient(
  {
    http: {
      baseUrl: getHttpApiUrl(),
    },
    websocket: {
      baseUrl: getWebsocketApiUrl(),
      retryAmount: 5,
      retryDelay: 5000,
    }
  }
);

export interface CompatibilityInfos {
  apiRest: CompatibilityInfoApiRest;
  websocketServer: CompatibilityInfoWebsocketServer;
}
export const getCompatibilityInfos = async (sdk: KastWebSdkClient): Promise<Partial<CompatibilityInfos>> => {
  const result: Partial<CompatibilityInfos> = {};
  const apiClient = sdk.getHttpClient();
  const websocketClient = sdk.getWebsocketClient();
  const apiRestCompatInfo = await apiClient?.getCompatibilityInfo();
  if (apiRestCompatInfo) {
    result.apiRest = apiRestCompatInfo;
    const websocketCompatInfo = await websocketClient?.getCompatibilityInfo(apiRestCompatInfo.apiVersion, "version");
    if (websocketCompatInfo) {
      result.websocketServer = websocketCompatInfo;
    }
  }
  return result;
};
